import React, { useState, useMemo } from 'react'
import { Form, Button, Icon } from 'semantic-ui-react'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import { useSubscription } from 'utils'
import { toast } from 'react-toastify'

export default function ConfrontarForm({ setConfronto }) {

    const [pdf, setPdf] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)

    function handleChange(event) {
        setPdf(event.target.files[0])
    }

    function handleSubmit(event) {
        event.currentTarget.querySelector('button').blur()
        if (!(!!pdf))
            toast.error('Por favor, selecionar o PDF a ser confrontado.')
        else 
            setIsSubmitting(true)
    }

    const submitForm$ = useMemo(() => {
        const form = new FormData()
        if (pdf)
            form.append('pdf', pdf)

        return request({ 
            url: '/dre/apuracao-icms/confrontar-prodac', 
            method: 'POST', 
            body: form 
        }).pipe(
            tap(({ response }) => setConfronto(response.result)),
            finalize(() => setIsSubmitting(false))
        )
    }, [pdf, setConfronto])

    useSubscription(submitForm$, isSubmitting)

    return (
        <Form size='mini' className='w-75' loading={isSubmitting} onSubmit={handleSubmit} noValidate>
            <div className="row pt-3">
                <div className="col">
                    <Form.Input type='file' accept='.pdf' required label='Relatório PDF da Prodac' name='prodac' onChange={handleChange}/>
                </div>
            </div>
            <div className="row pt-3">
                <div className="col text-center">
                    <Button animated='fade' size='mini' color='green'>
                        <Button.Content visible>{isSubmitting ? 'Enviando...' : 'Enviar'}</Button.Content>
                        <Button.Content hidden><Icon name='upload' /></Button.Content>
                    </Button>
                </div>
            </div>
        </Form>
    )
}
